import { lazyNamed } from "src/utils/lazy-named";

import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";

const destinationsImport = () => import("./destinations");

const CreateElement = lazyNamed(
  () => import("./create-destination"),
  "Element",
);
const DestinationElement = lazyNamed(() => import("./destination"), "Element");
const DestinationsElement = lazyNamed(destinationsImport, "Element");

export const preloads: RoutePreload[] = [["/destinations", destinationsImport]];
const GrantsElement = lazyNamed(
  () => import("./destination/grants"),
  "Element",
);
const SyncsElement = lazyNamed(() => import("./destination/syncs"), "Element");
const DataExtractionElement = lazyNamed(
  () => import("./destination/data-extraction"),
  "Element",
);
const LinkingElement = lazyNamed(
  () => import("./destination/linking"),
  "Element",
);
const ConfigurationElement = lazyNamed(
  () => import("./destination/configuration"),
  "Element",
);
const AlertingElement = lazyNamed(
  () => import("./destination/alerting"),
  "Element",
);

export const routes: Array<RouteObject> = [
  {
    path: "destinations",
    spacesAccess: "accessible-from-limited-view",
    element: <DestinationsElement />,
  },
  {
    path: "destinations/new",
    spacesAccess: "hidden-from-limited-view",
    element: <CreateElement />,
  },
  {
    path: "destinations/:destination_id/*",
    spacesAccess: "accessible-from-limited-view",
    element: <DestinationElement />,
    children: [
      {
        index: true,
        spacesAccess: "accessible-from-limited-view",
        element: <Navigate to="configuration" replace />,
      },
      {
        path: "configuration",
        spacesAccess: "accessible-from-limited-view",
        element: <ConfigurationElement />,
      },
      {
        path: "syncs",
        spacesAccess: "accessible-from-limited-view",
        element: <SyncsElement />,
      },
      {
        path: "permissions",
        spacesAccess: "accessible-from-limited-view",
        element: <GrantsElement />,
      },
      {
        path: "data-extraction",
        spacesAccess: "accessible-from-limited-view",
        element: <DataExtractionElement />,
      },
      {
        path: "linking",
        spacesAccess: "accessible-from-limited-view",
        element: <LinkingElement />,
      },
      {
        path: "alerting",
        spacesAccess: "accessible-from-limited-view",
        element: <AlertingElement />,
      },
    ],
  },
];
